<template>
  <v-dialog v-model="dialog" persistent width="500">
    <v-card>
      <input
        type="file"
        ref="image"
        style="display: none"
        accept="image/*"
        @change="onFilePicked"
      />
      <ModelTitle title="Images" @close="$emit('close')" />
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-btn :loading="loading" block color="info" @click="pickFile"
              >File From Computer</v-btn
            >
          </v-col>
          <v-col cols="12" class="ma-0 pa-0 text-center">OR</v-col>
          <v-col>
            <v-text-field
              v-model="loadUrl"
              outlined
              clearable
              @keyup.enter="loadImage"
              ref="imageUrl"
              :error-messages="urlError"
              :hide-details="urlError.length === 0"
              @focus="$event.target.select()"
              dense
              label="Enter URL"
            ></v-text-field>
          </v-col>
          <v-col class="shrink">
            <v-btn color="success" @click="loadImage">Load</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-if="images.length > 0">
        <v-row>
          <v-col
            v-for="n in images"
            :key="n"
            class="d-flex child-flex"
            cols="4"
          >
            <v-card flat class="d-flex" hover>
              <v-img
                @click="select(n)"
                :src="n"
                :lazy-src="n"
                aspect-ratio="1"
                class="grey lighten-2"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <div v-if="imageResult">
          <v-icon v-if="imageResult.searchType === 'database'"
            >mdi-database</v-icon
          >
          <v-icon v-else>mdi-web</v-icon>
        </div>

        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('close')">
          {{ $t("buttons.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const { validationMixin } = require("vuelidate");
const { url, required } = require("vuelidate/lib/validators");
import attachmentService from "@/modules/Attachment/service.js";

export default {
  props: ["imageResult", "showDialog", "field"],
  data() {
    return {
      loading: false,
      loadUrl: null,
      dialog: false,
      images: [],
      imageName: "",
      imageUrl: "",
      imageFile: "",
    };
  },
  mixins: [validationMixin],
  validations: {
    loadUrl: {
      required,
      url,
    },
  },
  watch: {
    showDialog(val) {
      this.dialog = val;
    },
    dialog(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.imageUrl.focus();
        }, 100);
      }
      // if (this.imageResult) {
      //   this.images = [];
      //   this.images.push(this.imageResult.imgUrl1);
      //   this.images.push(this.imageResult.imgUrl2);
      //   this.images.push(this.imageResult.imgUrl3);
      //   this.images.push(this.imageResult.imgUrl4);
      //   this.images.push(this.imageResult.imgUrl5);
      // }
    },
    imageResult() {
      this.images = [];
      this.images.push(this.imageResult.imgUrl1);
      this.images.push(this.imageResult.imgUrl2);
      this.images.push(this.imageResult.imgUrl3);
      this.images.push(this.imageResult.imgUrl4);
      this.images.push(this.imageResult.imgUrl5);
    },
  },
  computed: {
    urlError() {
      const errors = [];
      if (!this.$v.loadUrl.$dirty) return errors;
      if (!this.$v.loadUrl.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.loadUrl.url) errors.push("Valid URL");
      return errors;
    },
  },
  methods: {
    pickFile() {
      this.$refs.image.click();
    },

    optimizeImage(file, maxSize = 1000, quality = 0.78) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        const img = new Image();

        reader.onload = (event) => {
          img.onload = () => {
            let width = img.width;
            let height = img.height;

            if (width > height && width > maxSize) {
              height = Math.round((height * maxSize) / width);
              width = maxSize;
            } else if (height > maxSize) {
              width = Math.round((width * maxSize) / height);
              height = maxSize;
            }

            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext("2d");
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, width, height);
            ctx.drawImage(img, 0, 0, width, height);

            const base64 = canvas.toDataURL("image/jpeg", quality);
            resolve(base64);
          };

          img.onerror = reject;
          img.src = event.target.result;
        };

        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    async onFilePicked(e) {
      const files = e.target.files;

      if (!files || !files[0]) {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
        return;
      }

      const file = files[0];

      this.imageName = file.name;

      if (this.imageName.lastIndexOf(".") <= 0) {
        return;
      }

      this.loading = true;

      try {
        const optimizedImage = await this.optimizeImage(file, 1000, 0.78);
        const thumbnailImage = await this.optimizeImage(file, 240, 0.72);

        this.imageUrl = optimizedImage;
        this.imageFile = file;

        const result = await attachmentService.upload({
          base64: optimizedImage,
          thumbnailBase64: thumbnailImage,
          field: this.field,
          name: this.imageName,
        });

        if (result.status) {
          const imageUrl =
            result.data && result.data.imageUrl
              ? result.data.imageUrl
              : result.data;

          const thumbnailUrl =
            result.data && result.data.thumbnailUrl
              ? result.data.thumbnailUrl
              : null;

          this.images.push(thumbnailUrl || imageUrl);

          this.$emit("uploaded", result.data);
          this.loading = false;

          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: "Image is Uploaded!",
            });
        }
      } catch (error) {
        console.log("error", error);
        this.loading = false;
      }

      e.target.value = "";
    },

    loadImage() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });

        return;
      }

      this.images.push(this.loadUrl);
      this.loadUrl = null;
      this.$v.$reset();

      setTimeout(() => {
        this.$refs.imageUrl.focus();
      }, 100);
    },

    select(val) {
      this.$emit("submit", val);
    },
  },
};
</script>

<style scoped></style>
